let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8vZhS")).then(() => parcelRequire('8Pg2Y'));